import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';

// Consider single UI module
import { SidebarModule } from '@leagueplay/ui/sidebar';
import { SelectModule } from '@leagueplay/ui/select';
import { DropdownModule } from '@leagueplay/ui/dropdown';
import { TabsModule } from '@leagueplay/ui/tabs';

import { LocalStorageModule } from '@leagueplay/shared/local-storage';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { OrganizeComponent } from './organize/organize.component';
import { TournamentsComponent } from './tournaments/tournaments.component';
import { NavigationState } from '../stores/navigation/navigation.state';
import { TournamentState } from '../stores/tournament/tournament.state';
import { LoginComponent } from './login/login.component';
import { AuthState } from '../stores/auth/auth.state';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { CommunitiesComponent } from './communities/communities.component';
import { TournamentComponent } from './tournament/tournament.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OrganizeComponent,
    // todo: rename this to community
    TournamentsComponent,
    TournamentComponent,
    LoginComponent,
    UserProfileComponent,
    CommunitiesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    SelectModule,
    DropdownModule,
    TabsModule,
    SidebarModule,
    LocalStorageModule,
    NgxsModule.forRoot([AuthState, NavigationState, TournamentState]),
    RouterModule.forRoot([
      {
        path: '',
        component: HomeComponent,
        children: [
          {
            path: 'profile/:user',
            component: UserProfileComponent
          },
          {
            path: 'organize/:gameSlug',
            component: OrganizeComponent
          },
          {
            path: 'communities',
            component: CommunitiesComponent
          },
          {
            path: 'community/:communitySlug/tournament/:tournamentSlug',
            component: TournamentComponent
          },
          {
            path: 'community/:communitySlug',
            component: TournamentsComponent,
            // pathMatch: 'full',
            children: []
          }
        ]
      },
      {
        path: 'login',
        component: LoginComponent
      },

      { path: '**', redirectTo: '/' }
    ])
    // @TODO: Import /login routing module
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
